<div class="login-container">
  <mat-card class="login-card">
    <mat-card-header>
      <mat-card-title>Login</mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Username</mat-label>
          <input matInput formControlName="username" [disabled]="isLoading" autocomplete="username">
          @if (loginForm.get('username')?.hasError('required') && loginForm.get('username')?.touched) {
            <mat-error>Username is required</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Password</mat-label>
          <input matInput type="password" formControlName="password" [disabled]="isLoading" autocomplete="current-password">
          @if (loginForm.get('password')?.hasError('required') && loginForm.get('password')?.touched) {
            <mat-error>Password is required</mat-error>
          }
        </mat-form-field>

        <div class="button-container">
          @if (isLoading) {
            <mat-spinner diameter="30"></mat-spinner>
          } @else {
            <button mat-raised-button color="primary" type="submit" [disabled]="loginForm.invalid">
              Login
            </button>
          }
        </div>
      </form>
    </mat-card-content>
  </mat-card>
</div>
